import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';

import FormBaixaAgrupada from './FormBaixaAgrupada';

function DialogBaixaAgrupada({
    open,
    onClose,

    dados,
    itens,
    resumo,

    optionsConta,

    isLoading,
    isSubmitting,
    isSubmitDisabled,

    handleChange,
    submit,
}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle>Baixa Agrupada</DialogTitle>

            <DialogContent dividers>
                <FormBaixaAgrupada
                    dados={dados}
                    itens={itens}
                    resumo={resumo}
                    optionsConta={optionsConta}
                    isLoading={isLoading}
                    isSubmitting={isSubmitting}
                    isSubmitDisabled={isSubmitDisabled}
                    handleChange={handleChange}
                    submit={submit}
                    onClose={onClose}
                />
            </DialogContent>
        </Dialog>
    );
}

export default DialogBaixaAgrupada;
